// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import {perr} from 'hola_pub_util';
import hola_opt from 'hola_opt';
import etask from 'zetask';
import plus_util from '/www/hola/pub/plus_util.js';
// @ts-ignore
import {init} from '/www/hola/pub/plus_ui.js';
import {t_provider} from '../../../types';

const set_api_fix = (provider: t_provider)=>{
    const bluesnap = provider == 'bluesnap';
    plus_util.set_api({
        stripe_enabled: true,
        stripe: !bluesnap,
        bluesnap: bluesnap,
        bluesnap_hpf_enabled: true,
        avangate_2pay_enabled: false,
        avangate_enabled: false,
        gpay: false, // for bluesnap only
        gpay_stripe: true,
        applepay: false,
        payment_method: {method: 'cc', provider, type: 'api'},
        hola_pro: true,
    });
    plus_util.test.fallback_promo = false;
    if (location.href.indexOf('bluesnap')==-1)
        plus_util.test.cc_payment = false;
  };

const PAYMENT_SOURCE_REGEX =
    /(2pay\.js|bluesnap\.js|js\.stripe\.com|paypal\.com\/sdk\/js|pay\.google\.com)/;

export type t_payment_method = {provider: t_provider; fallback: t_provider};

const get_payment_method_from_config = (plan_id: string): t_payment_method=>{
    const plan = hola_opt.all_plans.find(p=>p.id==plan_id);
    if (plan && plan.price < 1)
      return {provider: 'stripe', fallback: 'bluesnap'};

    const country_name = hola_opt.user_country ?? 'US';
    const providers_config = hola_opt.www_hola.toolip_cards
        .map(c=>({...c,
            enabled: c.enabled[country_name] ?? c.enabled['*'] ?? 0}))
        .filter(c=>c.enabled > 0);
    const total_value = providers_config
        .reduce((prev, next)=>prev + next.enabled, 0);
    let rand = total_value*Math.random();
    for (const conf of providers_config)
    {
        if (conf.enabled >= rand)
            return conf;
        rand -= conf.enabled;
    }
    return providers_config[0] ?? {provider: 'stripe', fallback: 'bluesnap'};
};

const get_test_payment_method = (provider: t_provider): t_payment_method=>{
    return hola_opt.www_hola.toolip_cards.find(c=>c.provider == provider) ??
        {provider, fallback: provider != 'stripe' ? 'stripe' : 'bluesnap'};
};

export const get_payment_method = (plan_id: string): t_payment_method=>{
    for (const provider of ['stripe', 'bluesnap', 'adyen'] as const)
    {
        if (location.href.includes(provider))
            return get_test_payment_method(provider);
    }
    return get_payment_method_from_config(plan_id);
};

export const on_toolip_init = (plan_id: string)=>etask(function*(){
    const method = get_payment_method(plan_id);
    set_api_fix(method.provider);
    const script_err = {};
    const on_script_load_err: OnErrorEventHandler = ev=>{
        const src =
            (ev as Event & {target: HTMLScriptElement})?.target?.src ?? '';
        const match = src.match(PAYMENT_SOURCE_REGEX);
        if (match)
        {
            const name = match[1];
            perr({id: 'www_toolip_premium_payment_script_load_err',
                info: {src}});
            Object.assign(script_err, {[name]: true});
            console.error(`Cannot load script ${src}`);
        }
    };
    yield init(plus_util.api, on_script_load_err);
    return method;
});
